import checkValidOp from "./checkValidOp";

// indexes for the ref map

// top-level index is object-{objectId} to identify the specific whiteboard object
const index1 = (p) => p.slice(0, 2).join("-");

// second level identifies the specific object property by the rest of the path
const index2 = (p) => p.slice(2).join("-");

function compose(op1, op2) {
  if (!op1) op1 = [];
  if (!op2) op2 = [];
  if (!Array.isArray(op1)) op1 = [op1];
  if (!Array.isArray(op2)) op2 = [op2];
  checkValidOp(op1);
  checkValidOp(op2);

  // combine ops into one array
  const ops = op1.concat(op2);

  if (ops.length <= 1) {
    return ops;
  }

  const len = ops.length;
  const op1Length = op1.length;

  // capture ops of interest as we go, in an optimised lookup format so we can efficiently
  // retrieve them for compaction with earlier ops
  // nested map, looks like Map<string, Map<string, [Op, number]>>
  const refs = new Map();

  // record ops for later deletion, so that we don't need to change the array while
  // iterating
  const deleteIndices = [];

  // traverse backwards through the combined array
  for (let i = len - 1; i >= 0; i--) {
    const op = ops[i];

    if (op.hasOwnProperty("cp")) {
      // for each update op
      // check for later matching op (stored already because we're iterating in reverse)
      let matches = refs.get(index1(op.p));

      const match = matches?.get(index2(op.p))?.[0];

      if (match) {
        // if it's updating the same property, update stored op for undo
        match.dp = op.dp;

        // and mark this one for deletion
        deleteIndices.push(i);
      } else {
        // otherwise store op - this is the latest update for that object/property that we
        // want to keep
        // only store ops from op2 as we assume op1 is already compacted
        // note we still iterate back through op1 to find create ops below, we just don't
        // store them for lookup

        if (i >= op1Length) {
          if (!matches) {
            matches = new Map();
            refs.set(index1(op.p), matches);
          }
          matches.set(index2(op.p), [op, i]);
        }
      }
    } else if (op.hasOwnProperty("co")) {
      // for each create op, find any later matching update ops
      const matches = refs.get(index1(op.p));
      matches?.forEach(([match, matchIndex]) => {
        // copy assignment to create op, only for single-level updates
        if (match.p.length === 3) {
          op.co[match.p[2]] = match.cp;

          // and mark update for deletion
          deleteIndices.push(matchIndex);
        }
      });
    }
  }

  // sort deletions numerically so we can delete in reverse order
  deleteIndices.sort((a, b) => a - b);
  for (let i = deleteIndices.length - 1; i >= 0; i--) {
    ops.splice(deleteIndices[i], 1);
  }

  return ops;
}

export default compose;
